import type { AuthClient } from "@jetblue/kit-auth";
import { createAuthClient, looksLikeCallback } from "@jetblue/kit-auth";
import { createOktaProvider } from "@jetblue/kit-auth-provider-okta";
import type { KitAuthConfig } from "../../types";

let cached: AuthClient | undefined;

export const kitAuthClientSetup = (kitAuthConfig: KitAuthConfig) => {
  if (cached) {
    return cached;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Will be fixed when the globalThis be fixed.
  const currentUrl = globalThis.location?.href ?? "";

  cached = createAuthClient({
    autoRestore: !looksLikeCallback(currentUrl),
    broadcastChannel: "dotcom-kit-auth",
    provider: createOktaProvider({
      clientId: kitAuthConfig.CLIENT_ID,
      issuer: kitAuthConfig.ISSUER,
      postLogoutRedirectUri: kitAuthConfig.POST_LOGOUT_REDIRECT_URI,
      redirectUri: kitAuthConfig.REDIRECT_URI,
      signInUrl: kitAuthConfig.SIGN_IN_URL,
      storage: kitAuthConfig.STORAGE,
    }),
  });
  return cached;
};
